function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background-image: ",
        ";\n  background-position: center;\n  background-size: cover;\n\n  border-radius: ",
        " 0 0\n    ",
        ";\n  min-height: 148px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 43%;\n\n  @media ",
        " {\n    right: 0;\n    border-radius: ",
        ";\n    background-image: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  cursor: pointer;\n  display: inline;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 175%;\n  color: #0b99e6;\n  white-space: nowrap;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  z-index: 200;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: inline;\n  font-size: 13px;\n  line-height: 165%;\n  color: #fff;\n  word-break: break-word;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 24px;\n  color: #fff;\n  margin-bottom: 11px;\n  word-break: break-word;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  min-height: 148px;\n  border-radius: ",
        ";\n  display: flex;\n  padding: 47px 55px;\n  margin-bottom: 55px;\n\n  ",
        "\n\n  background-color: #0b1f32;\n  position: relative;\n\n  @media ",
        " {\n    margin-bottom: 20px;\n    min-width: 325px;\n    min-height: 179px;\n    padding: 70px 25px 25px;\n    flex-direction: column;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { mediaQueries } from 'shared/styles';
import { DEFAULT_SPECIALS_CARD_IMG } from 'shared/constants';
import { replaceAWSSourceWithImgix } from 'shared/helpers/imgix';
import { useMediaQuery } from '@material-ui/core';
var LONG_DESCRIPTION_MIN_LENGTH_MOBILE = 85;
var LONG_DESCRIPTION_MIN_LENGTH = 213;
export default function IndividualBogoCard(param) {
    var displayImage = param.displayImage, displayName = param.displayName, displayDescription = param.displayDescription, _param_showExpiredSpecial = param.showExpiredSpecial, showExpiredSpecial = _param_showExpiredSpecial === void 0 ? false : _param_showExpiredSpecial;
    var _useState = _sliced_to_array(useState(false), 2), showAllText = _useState[0], setShowAllText = _useState[1];
    var isMobile = useMediaQuery(mediaQueries.phone);
    var longDescriptionMinLength = isMobile ? LONG_DESCRIPTION_MIN_LENGTH_MOBILE : LONG_DESCRIPTION_MIN_LENGTH;
    var isLongDescription = (displayDescription === null || displayDescription === void 0 ? void 0 : displayDescription.length) >= longDescriptionMinLength;
    var defaultDescription = !isLongDescription ? displayDescription : _.truncate(displayDescription, {
        length: longDescriptionMinLength
    });
    function showHideDescription() {
        setShowAllText(function(prevShowAllText) {
            return !prevShowAllText;
        });
    }
    return /*#__PURE__*/ _jsxs(IndividualBogoCardContainer, {
        showExpiredSpecial: showExpiredSpecial,
        children: [
            /*#__PURE__*/ _jsx(BackgroundImageContainer, {
                imageUrl: replaceAWSSourceWithImgix(displayImage) || DEFAULT_SPECIALS_CARD_IMG
            }),
            /*#__PURE__*/ _jsxs(IndividualBogoTextContainer, {
                children: [
                    /*#__PURE__*/ _jsx(IndividualBogoTitle, {
                        children: displayName
                    }),
                    defaultDescription && /*#__PURE__*/ _jsxs(IndividualBogoDescription, {
                        children: [
                            showAllText ? displayDescription : defaultDescription,
                            "\xa0",
                            isLongDescription && /*#__PURE__*/ _jsx(DescriptionExpanderLink, {
                                onClick: showHideDescription,
                                children: showAllText ? 'Show less' : 'Show more'
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var BackgroundImageContainer = styled.div(_templateObject(), function(param) {
    var imageUrl = param.imageUrl;
    return "linear-gradient(90deg, rgba(11, 31, 50, 0.38) 0%, #0B1F32 100%), url(".concat(imageUrl, ")");
}, function(param) {
    var theme = param.theme;
    var _theme_customized_radius, _theme_customized;
    var _theme_customized_radius_lg;
    return (_theme_customized_radius_lg = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_radius = _theme_customized.radius) === null || _theme_customized_radius === void 0 ? void 0 : _theme_customized_radius.lg) !== null && _theme_customized_radius_lg !== void 0 ? _theme_customized_radius_lg : '20px';
}, function(param) {
    var theme = param.theme;
    var _theme_customized_radius, _theme_customized;
    var _theme_customized_radius_lg;
    return (_theme_customized_radius_lg = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_radius = _theme_customized.radius) === null || _theme_customized_radius === void 0 ? void 0 : _theme_customized_radius.lg) !== null && _theme_customized_radius_lg !== void 0 ? _theme_customized_radius_lg : '20px';
}, mediaQueries.phone, function(param) {
    var theme = param.theme;
    var _theme_customized_radius, _theme_customized;
    var _theme_customized_radius_lg;
    return (_theme_customized_radius_lg = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_radius = _theme_customized.radius) === null || _theme_customized_radius === void 0 ? void 0 : _theme_customized_radius.lg) !== null && _theme_customized_radius_lg !== void 0 ? _theme_customized_radius_lg : '20px';
}, function(param) {
    var imageUrl = param.imageUrl;
    return "linear-gradient(180deg, rgba(11, 31, 50, 0.11) 0%, #0B1F32 66.59%), url(".concat(imageUrl, ")");
});
var DescriptionExpanderLink = styled.span(_templateObject1());
var IndividualBogoTextContainer = styled.div(_templateObject2());
var IndividualBogoDescription = styled.p(_templateObject3());
var IndividualBogoTitle = styled.h3(_templateObject4());
var IndividualBogoCardContainer = styled.div(_templateObject5(), function(param) {
    var theme = param.theme;
    var _theme_customized_radius, _theme_customized;
    var _theme_customized_radius_lg;
    return (_theme_customized_radius_lg = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_radius = _theme_customized.radius) === null || _theme_customized_radius === void 0 ? void 0 : _theme_customized_radius.lg) !== null && _theme_customized_radius_lg !== void 0 ? _theme_customized_radius_lg : '20px';
}, function(props) {
    return props.showExpiredSpecial && "\n    filter: grayscale(80%) opacity(0.75);\n  ";
}, mediaQueries.phone);
